import { useTheme, Grid, Typography, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppBaseButton } from 'components/AppBaseButton/AppBaseButton';
import { ReactElement } from 'react';

type CalculationResultsPanelInfoProps = {
  title: string;
  infoText: string;
  showSpinner?: boolean;
  handleCancel?: () => void;
};

export function CalculationResultsPanelInfo({
  title,
  infoText,
  showSpinner = false,
  handleCancel,
}: CalculationResultsPanelInfoProps): ReactElement {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2} sx={{ height: '100%' }}>
      {showSpinner && (
        <Grid item>
          <CircularProgress size={30} />
        </Grid>
      )}
      <Grid item>
        <Typography variant="h6" fontFamily="KingspanBrownTT-Bold" align="center">
          {title}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body2" color={theme.palette.grey[500]} align="center" px={8}>
          {infoText}
        </Typography>
      </Grid>
      {handleCancel && (
        <Grid item>
          <AppBaseButton onClick={handleCancel}>{t('calculation-page.results-panel.cancel-button')}</AppBaseButton>
        </Grid>
      )}
    </Grid>
  );
}
